import * as React from 'react';
import { useState } from 'react';
import { IYado, ICurrency } from '../types';
import { YadoItemView, YadoItemTopView, YadoItemBottomView } from './views/YadoItemView';
import YadoItemPhoto from './YadoItemPhoto';
import YadoItemContentView from './views/YadoItemContentView';
import YadoItemPrice from '../YadoItem/YadoItemPrice';
import YadoResortSection from '../YadoItem/YadoResortSection';
import { resortSectionTitle, sortResorts } from '../helpers';
import { flatten } from '../../utils/commonHelper';
import YadoItemResort from '../YadoItem/YadoItemResort';
import YadoResortSectionTitleView from '../YadoItem/views/YadoResortSectionTitleView';

interface IProps {
  yado: IYado;
  uri: string;
  handleClick: null|((event: React.MouseEvent) => void);
  numberOfPeople: number,
  numberOfNights: number,
  currency: ICurrency,
}

const YadoItem: React.FC<IProps> = (props) => {
  const { yado, uri, handleClick, currency } = props;
  const { resorts } = yado;

  const [isToggled, toggle] = useState<boolean>(false);

  const closeResorts = sortResorts(resorts);
  const sorted = flatten(Object.values(closeResorts));
  const firstResort = sorted[0];
  const moreCount = sorted.length - 1;

  function handleToggleClick(event: React.MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    toggle(!isToggled);
  }

  function renderBottom() {
    const resortTitle = resortSectionTitle([firstResort]);
    if (firstResort == null || resortTitle == null) { return null; }
    return (
      <YadoItemBottomView>
        <div className="first-resort">
          <div>
            <YadoResortSectionTitleView>{resortTitle}</YadoResortSectionTitleView>
            <YadoItemResort
              currency={currency}
              name={firstResort.name}
              code={firstResort.code}
              lift_min_price={firstResort.lift_min_price}
              rental_min_price={firstResort.rental_min_price} />
          </div>
          {moreCount > 0 &&
            <span className="toggle" onClick={handleToggleClick}>
            <i className={`fa fa-angle-${isToggled ? 'up' : 'down'}`} />
          </span>}
        </div>
        {moreCount > 0 && isToggled &&
          <div style={{ marginTop: '1em' }}>
            <YadoResortSection currency={currency} resorts={closeResorts.adjacent} exclude={[firstResort]} />
            <YadoResortSection currency={currency} resorts={closeResorts.walk} exclude={[firstResort]} />
            <YadoResortSection currency={currency} resorts={closeResorts.shuttleBus} exclude={[firstResort]} />
          </div>
        }
      </YadoItemBottomView>
    )
  }

  return (
    <YadoItemView href={uri} onClick={handleClick} target="_blank" rel="noopener noreferrer">
      <YadoItemTopView>
        <YadoItemPhoto yado={yado} />
        <YadoItemContentView>
          <div>
            <p className="title">{yado.name}</p>
            <p className="title-en">{yado.name_en}</p>
          </div>
          <YadoItemPrice {...props} />
        </YadoItemContentView>
      </YadoItemTopView>
      {renderBottom()}
    </YadoItemView>
  );
}

export default YadoItem;
